import { IStore } from "../types/IStore";

export const pharmacyRatingItems = (state: IStore) => state.professional.ratingItems;
export const pharmacyRating = (state: IStore) => state.professional.rating;
export const pharmacyBookedRating = (state: IStore) => state.professional.bookedRating;
export const professionalInvoice = (state: IStore) => state.professional.invoiceDetails;
export const generatedProfessionalInvoice = (state: IStore) => state.professional.professionalInvoice;